import dayjs from "dayjs";
import { Note } from "../../hooks/react-query/linehaul/useLoadBoardNotes";

export const mockScheduleNotes = {
  default: [
    {
      id: 1,
      content: "Test Note",
      createdBy: "Test User",
      createdOn: dayjs().toDate(),
      modifiedBy: "Test User",
      modifiedOn: dayjs().toDate(),
      isEdited: false,
      scheduleId: 1,
    },
  ],
} as const satisfies Record<string, Note[]>;
